// extracted by mini-css-extract-plugin
module.exports = {"Minimize":"Minimize-module__Minimize___1R0jk"};